(() => {
  'use strict';
  class CardQuickAdd extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.card = this.closest('.product-card');
      this.form = this.querySelector('[data-quick-form]');
      this.openButton = this.querySelector('[data-quick-open]');
      if (!this.form || !this.openButton) return;
      this.copy = this.card.querySelector('[data-quick-copy]');
      this.media = this.card.querySelector('.ls-card-media');
      this.image = this.card.querySelector('.product-image img');
      this.badge = this.card.querySelector('.badge');
      this.original = {
        src: this.image?.getAttribute('src'),
        srcset: this.image?.getAttribute('srcset'),
        alt: this.image?.getAttribute('alt'),
        badge: this.badge?.textContent,
        badgeHidden: this.badge?.hidden
      };
      this.openButton.addEventListener('click', event => {
        event.preventDefault();
        this.open();
      });
      this.querySelector('[data-quick-cancel]').addEventListener('click', () => this.close());
      this.form.addEventListener('keydown', event => {
        if (event.key === 'Tab') {
          const controls = [...this.form.querySelectorAll('button:not(:disabled), input:not(:disabled), a[href]')].filter(node => node.getClientRects().length);
          const first = controls[0], last = controls.at(-1);
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
        }
        if (event.key === 'Escape') {
          event.preventDefault();
          this.close();
        }
      });
      this.form.addEventListener('change', event => {
        if (event.target.name === 'id') this.update();
      });
      this.querySelectorAll('[data-quantity-step]').forEach(button => {
        button.addEventListener('click', () => {
          const input = this.form.elements.quantity;
          if (Number(button.dataset.quantityStep) > 0) input.stepUp();
          else if (Number(input.value) > 1) input.stepDown();
          if (!input.value || Number(input.value) < 1) input.value = '1';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      this.form.addEventListener('submit', event => this.add(event));
    }
    open() {
      if (CardQuickAdd.active && CardQuickAdd.active !== this) {
        if (CardQuickAdd.active.busy) return;
        CardQuickAdd.active.close(false, false);
      }
      if (this.busy) return;
      this.animation?.cancel();
      this.closing = false;
      CardQuickAdd.active = this;
      this.form.hidden = false;
      this.openButton.setAttribute('aria-expanded', 'true');
      if (this.copy) this.copy.inert = true;
      if (this.media) this.media.inert = true;
      this.form.inert = false;
      this.card.classList.add('is-quick-open');
      this.form.scrollTop = 0;
      this.update();
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.animation = this.form.animate([{ opacity: 0, transform: 'translateY(24px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 260, easing: 'cubic-bezier(.2,.7,.2,1)' });
      }
      (this.form.querySelector('[name="id"]:checked') || this.form.querySelector('[name="id"]:not(:disabled)'))?.focus({ preventScroll: true });
    }
    update() {
      const selected = this.form.querySelector('[name="id"]:checked');
      if (!selected) return;
      const price = this.querySelector('[data-quick-price]');
      price.replaceChildren(document.createTextNode(selected.dataset.price));
      if (selected.dataset.compare) {
        const compare = document.createElement('s');
        compare.className = 'compare';
        compare.textContent = selected.dataset.compare;
        price.append(' ', compare);
      }
      if (this.image && selected.dataset.image) {
        this.image.removeAttribute('srcset');
        this.image.src = selected.dataset.image;
        this.image.alt = selected.dataset.imageAlt;
      }
      if (this.badge) {
        this.badge.hidden = !selected.dataset.off;
        this.badge.textContent = selected.dataset.off;
      }
      this.querySelector('[data-quick-error]').hidden = true;
    }
    close(restoreFocus = true, animate = true) {
      if (this.busy) return;
      this.animation?.cancel();
      if (animate && !this.form.hidden && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.closing = true;
        this.form.inert = true;
        this.animation = this.form.animate([{ opacity: 1, transform: 'translateY(0)' }, { opacity: 0, transform: 'translateY(24px)' }], { duration: 180, easing: 'ease-in', fill: 'forwards' });
        this.animation.onfinish = () => this.close(restoreFocus, false);
        return;
      }
      this.closing = false;
      this.form.hidden = true;
      this.form.inert = false;
      this.openButton.setAttribute('aria-expanded', 'false');
      if (this.copy) this.copy.inert = false;
      if (this.media) this.media.inert = false;
      this.card.classList.remove('is-quick-open');
      if (CardQuickAdd.active === this) CardQuickAdd.active = null;
      if (this.image) {
        if (this.original.src) this.image.setAttribute('src', this.original.src);
        if (this.original.srcset) this.image.setAttribute('srcset', this.original.srcset);
        else this.image.removeAttribute('srcset');
        this.image.setAttribute('alt', this.original.alt || '');
      }
      if (this.badge) {
        this.badge.textContent = this.original.badge;
        this.badge.hidden = this.original.badgeHidden;
      }
      if (restoreFocus) this.openButton.focus({ preventScroll: true });
    }
    async add(event) {
      event.preventDefault();
      if (this.busy || !this.form.reportValidity()) return;
      this.busy = true;
      const submit = this.querySelector('[data-quick-submit]');
      const label = submit.textContent;
      const error = this.querySelector('[data-quick-error]');
      const labels = JSON.parse(document.getElementById('CatalogLabels')?.textContent || '{}');
      error.hidden = true;
      submit.disabled = true;
      submit.textContent = labels.adding || label;
      this.form.setAttribute('aria-busy', 'true');
      const root = window.Shopify?.routes?.root || '/';
      try {
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(this.form)
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || labels.error);
        const toast = document.getElementById('Toast');
        if (toast) {
          toast.textContent = labels.added;
          toast.classList.add('show');
          window.setTimeout(() => toast.classList.remove('show'), 2600);
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item: data } }));
        try {
          const cartResponse = await fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } });
          if (cartResponse.ok) {
            const cart = await cartResponse.json();
            document.querySelectorAll('.lsn-cart-count').forEach(count => { count.textContent = cart.item_count; });
            document.querySelectorAll('.lsn-cart').forEach(link => { link.setAttribute('aria-label', labels.cart.replace('[count]', cart.item_count)); });
          }
        } catch {}
        this.busy = false;
        this.close();
      } catch (problem) {
        error.textContent = problem.message || labels.error;
        error.hidden = false;
      } finally {
        this.busy = false;
        submit.disabled = false;
        submit.textContent = label;
        this.form.removeAttribute('aria-busy');
      }
    }
  }
  if (!customElements.get('ls-card-quick-add')) customElements.define('ls-card-quick-add', CardQuickAdd);
  function initialiseFilters(scope = document) {
    scope.querySelectorAll('.ls-mobile-filters').forEach(panel => {
      if (panel.dataset.ready) return;
      panel.dataset.ready = 'true';
      if (window.matchMedia('(max-width: 749px)').matches) panel.open = false;
    });
    scope.querySelectorAll('[data-price-range]').forEach(group => {
      if (group.dataset.ready) return;
      group.dataset.ready = 'true';
      const min = group.querySelector('[data-price-min]');
      const max = group.querySelector('[data-price-max]');
      const low = group.querySelector('[data-range-min]');
      const high = group.querySelector('[data-range-max]');
      const ceiling = Number(high.max);
      const refresh = source => {
        let lower = Number(min.value || 0);
        let upper = Number(max.value || ceiling);
        if (source === low) lower = Number(low.value);
        if (source === high) upper = Number(high.value);
        lower = Math.max(0, Math.min(lower, ceiling));
        upper = Math.max(0, Math.min(upper, ceiling));
        if (lower > upper) {
          if (source === low || source === min) lower = upper;
          else upper = lower;
        }
        low.value = lower;
        high.value = upper;
        if (source) {
          min.value = lower;
          max.value = upper;
        }
        min.max = upper;
        max.min = lower;
        const track = group.querySelector('.ls-price-track');
        track.style.setProperty('--low', ceiling ? lower / ceiling * 100 + '%' : '0%');
        track.style.setProperty('--high', ceiling ? upper / ceiling * 100 + '%' : '100%');
      };
      [min, max, low, high].forEach(input => input.addEventListener('input', () => refresh(input)));
      refresh();
      group.classList.add('is-enhanced');
    });
    scope.querySelectorAll('[data-filter-auto]').forEach(input => {
      if (input.dataset.ready) return;
      input.dataset.ready = 'true';
      input.addEventListener('change', () => input.form.requestSubmit());
    });
    scope.querySelectorAll('[data-catalog-sort]').forEach(select => {
      if (select.dataset.ready) return;
      select.dataset.ready = 'true';
      select.addEventListener('change', () => select.form.requestSubmit());
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialiseFilters());
  else initialiseFilters();
  document.addEventListener('shopify:section:load', event => initialiseFilters(event.target));
})();
